import { defineStore } from "pinia";
import { getMarketingMessageList, marketingClearUnread } from "@/api";
// import { Env, getLocalStorage } from "@voghion/fe-util";

export interface goodsItemType {
  categoryId: number;
  commentNumber: number;
  createTime: string;
  dataType: string;
  description: number;
  discountLabel: string;
  endTime: string;
  extraInfo: string;
  goodsCardVO: {
    backgroundImg: string;
    endTime: number;
    goodsInfo: [
      {
        discountLabel: string;
        extraInfo: string;
        goodsId: number;
        goodsName: string;
        imgUrl: string;
        marketPrice: number;
        originalName: string;
        price: number;
        routeUrl: string;
        skuId: number;
        sold: number;
      },
    ];
    interval: number;
    isShowDay: number;
    lessTime: number;
    routeUrl: string;
    styleType: number;
    tagImg: string;
  };
  goodsDesc: string;
  goodsId: number;
  goodsName: string;
  grouponPrice: number;
  id: number;
  imgUrl: string;
  imgUrlH: number;
  imgUrlW: number;
  marketPrice: number;
  onlyGoodsId: string;
  originalName: string;
  price: number;
  productType: number;
  qualityStoreImgsVO: {
    backgroundImg: string;
    bigImgs: string[];
    smallImgs: string[];
  };
  recommendGoodsImg: string;
  remainLeft: string;
  routeUrl: string;
  sales: number;
  score: number;
  selectedItem: {
    marketPrice: number;
    minPurchaseQuantity: number;
    price: number;
    skuId: number;
    skuName: string;
    stock: number;
  };
  shopCommentNumber: number;
  shopId: number;
  shopName: string;
  shopScore: number;
  site: string;
  skuId: number;
  sold: number;
  sort: number;
  status: number;
  stock: number;
  subTitle: string;
  tagInfoList: [
    {
      activityCountry: string;
      activityId: number;
      activityName: string;
      activityType: number;
      detailImg: string;
      endTime: number;
      jumpType: number;
      labelImg: string;
      lessTime: number;
      position: number;
      preColor: string;
      preTitle: string;
      routeUrl: string;
      tagImg: string;
      tagTitle: string;
      textColor: string;
    },
  ];
  tagInfoMap: {
    additionalProp1: [
      {
        activityCountry: string;
        activityId: number;
        activityName: string;
        activityType: number;
        detailImg: string;
        endTime: number;
        jumpType: number;
        labelImg: string;
        lessTime: number;
        position: number;
        preColor: string;
        preTitle: string;
        routeUrl: string;
        tagImg: string;
        tagTitle: string;
        textColor: string;
      },
    ];
    additionalProp2: [
      {
        activityCountry: string;
        activityId: number;
        activityName: string;
        activityType: number;
        detailImg: string;
        endTime: number;
        jumpType: number;
        labelImg: string;
        lessTime: number;
        position: number;
        preColor: string;
        preTitle: string;
        routeUrl: string;
        tagImg: string;
        tagTitle: string;
        textColor: string;
      },
    ];
    additionalProp3: [
      {
        activityCountry: string;
        activityId: number;
        activityName: string;
        activityType: number;
        detailImg: string;
        endTime: number;
        jumpType: number;
        labelImg: string;
        lessTime: number;
        position: number;
        preColor: string;
        preTitle: string;
        routeUrl: string;
        tagImg: string;
        tagTitle: string;
        textColor: string;
      },
    ];
  };
  tagList: [
    {
      detail: string;
      tagMsg: string;
      tagType: string;
    },
  ];
  title: string;
  type: string;
  valid: true;
  value: string;
  videoUrl: string;
  wishGoods: true;
}

export interface marketingType {
  content: string;
  goodsItemList: Array<goodsItemType>;
  icon: string;
  pushTime: string;
  read: boolean;
  skipUrl: string;
  title: string;
  type: number;
  unreadNum: number;
}

// const newinCacheKey = "zoomies_newin";
// const storage = getLocalStorage();

export const useNewinStore = defineStore("newin", {
  state: () => {
    return {
      marketingData: null as marketingType | null,
      marketingDataList: [] as Array<marketingType>,
      loading: false as boolean,
    };
  },
  actions: {
    getMarketing() {
      // const env = Env.getInstance();
      // if (!env.isApp()) {
      //   return;
      // }
      this.loading = true;
      getMarketingMessageList()
        .then((res: any) => {
          if (res.rtn_code === "0000") {
            if (res?.data?.marketingDataList?.length > 0) {
              const data =
                res?.data?.marketingDataList[
                res?.data?.marketingDataList.length - 1
                ];
              // if (data.read === false && data.unreadNum === 0) {
              //   // 2-48的整数
              //   data.unreadNum = 1;
              // } else if (data.unreadNum > 99) {
              //   data.unreadNum = "99+";
              // }
              // storage.setItem(newinCacheKey, data);
              this.marketingData = data;
            }
            this.marketingDataList = res?.data?.marketingDataList;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // clearMarketingUnread() {
    //   const env = Env.getInstance();
    //   if (!env.isApp()) {
    //     return;
    //   }

    //   this.loading = true;

    //   marketingClearUnread({ type: 1 })
    //     .then((res: any) => {
    //       if (res.rtn_code === "0000") {
    //         this.getMarketing();
    //       } else {
    //         this.loading = false;
    //       }
    //     })
    //     .catch(() => {
    //       this.loading = false;
    //     });
    // },
    // clearUnread() {
    //   const env = Env.getInstance();
    //   if (!env.isApp()) {
    //     return;
    //   }

    //   this.marketingData = { ...this.marketingData, unreadNum: 0 };
    // },
    // clearCache() {
    //   storage.removeItem(newinCacheKey);
    // },
  },
});
